import DeviationMediaService, { fallbackToLargestFile, } from '../../../../utils/DeviationMediaService';
import ddt from '@wix/da-ddt';
import { isValidFileSrc } from '../../../../DeviationViews/_helpers';
export var getImageStylesAndSrc = function (deviation, propsWidth, config, containerWidth) {
    ddt.log('measuredhook', 'Image - container width', { containerWidth: containerWidth });
    var fullview = DeviationMediaService.getLargestFullview(deviation);
    if (!fullview) {
        ddt.log('Editor', 'Not rendering mono image - no fullview', deviation);
        return false;
    }
    // Calculate the width and height of the block
    var fvImageRatio = (fullview.width || 0) / (fullview.height || 0);
    var coverWidth = propsWidth === 'static' ? 780 : propsWidth || 780;
    var coverHeight = coverWidth / fvImageRatio;
    var coverThumb = DeviationMediaService.getSmallestThumbThatFullyCovers(deviation, coverWidth, coverHeight, fallbackToLargestFile, { allowFullview: true, allowPreview: true });
    if (!coverThumb || !isValidFileSrc(coverThumb.src)) {
        ddt.log('Editor', 'Not rendering mono image', deviation);
        return false;
    }
    // Dont stretch things - max is the fullview width
    // we then let browser decide whats best using srcset
    var imgWidth = '100%';
    if (!propsWidth || (fullview.width || 0) < propsWidth) {
        imgWidth = fullview.width;
    }
    var wrapperStyles = {};
    if (propsWidth !== 'static') {
        var actualWidth = propsWidth || containerWidth;
        // Dont over pad small images
        var boundHeight = actualWidth / fvImageRatio;
        if (fullview.height && boundHeight > fullview.height) {
            boundHeight = fullview.height;
        }
        ddt.log('measuredhook', 'Image size', {
            actualWidth: actualWidth,
            propsWidth: propsWidth,
            containerWidth: containerWidth,
            boundHeight: boundHeight,
            fvImageRatio: fvImageRatio,
            fvHeight: fullview.height,
        });
        wrapperStyles = {
            margin: '0 auto',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden',
            width: actualWidth || '100%',
            height: "".concat(boundHeight, "px"),
        };
    }
    var imgStyles = {};
    if (propsWidth !== 'static') {
        imgStyles = {
            flexGrow: 0,
            flexShrink: 0,
            width: imgWidth,
            maxWidth: '100%',
            display: 'block' /* fixes wrappers not being correct height */,
        };
    }
    var allowFullview = (fullview.width || 0) > (propsWidth || 0);
    var canBeLinked = config.link || deviation.isPublished;
    return {
        allowFullview: allowFullview,
        canBeLinked: canBeLinked,
        imgStyles: imgStyles,
        wrapperStyles: wrapperStyles,
        coverThumb: coverThumb,
        fullview: fullview,
    };
};
//# sourceMappingURL=helpers.js.map